import React, { useEffect, useState } from 'react';
import './App.css';
import twitterLogo from './assets/twitter-logo.svg';
import CandyMachine from './CandyMachine';
import { Row, Col, Container,Image} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import chimpz1 from "./assets/1.png";
import chimpz2 from './assets/2.png'
import chimpz3 from './assets/3.png'


// Constants
const TWITTER_HANDLE = '_buildspace';
const TWITTER_LINK = `https://twitter.com/${TWITTER_HANDLE}`;

const App = () => {
  // State
  const [walletAddress, setWalletAddress] = useState(null);

  // Actions
  const checkIfWalletIsConnected = async () => {
    try {
      const { solana } = window;
  
      if (solana) {
        if (solana.isPhantom) {
          console.log('Phantom wallet found!');
          const response = await solana.connect({ onlyIfTrusted: true });
          console.log(
            'Connected with Public Key:',
            response.publicKey.toString()
          );
  
          /*
           * Set the user's publicKey in state to be used later!
           */
          setWalletAddress(response.publicKey.toString());
        }
      } else {
        alert('Solana object not found! Get a Phantom Wallet 👻');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const connectWallet = async () => {
    const { solana } = window;
  
    if (solana) {
      const response = await solana.connect();
      console.log('Connected with Public Key:', response.publicKey.toString());
      setWalletAddress(response.publicKey.toString());
    }
  };

  const renderNotConnectedContainer = () => (
    <button
      className="cta-button connect-wallet-button"
      onClick={connectWallet}
    >
      Connect to Wallet
    </button>
  );

  useEffect(() => {
    const onLoad = async () => {
      await checkIfWalletIsConnected();
    };
    window.addEventListener('load', onLoad);
    return () => window.removeEventListener('load', onLoad);
  }, []);

  
  return (
    <div className="App">
      <Container>
        <div className="header-container">
          <div className="Col">

          </div>
          <p className="header">🍭 Welcome to Chimp Skool 🍭</p>
          <div className="row">
            <div className="col-sm-4 image">
              <Image src={chimpz1} className="image_size"></Image>
              <p className="legend">Chimpz</p>
            </div>
            <div className="col-sm-4 image">
              <Image src={chimpz2} className="image_size"></Image>
              <p className="legend" >Chimpz</p>
            </div>
            <div className="col-sm-4 image">
              <Image src={chimpz3} className="image_size"></Image>
              <p className="legend">Chimpz</p>
            </div>
          </div>
          {!walletAddress && renderNotConnectedContainer()}
        </div>
        {/* Check for walletAddress and then pass in walletAddress */}
        {walletAddress && <CandyMachine walletAddress={window.solana} />} 
        <div>
          <p className="header">🍭 FAQ  🍭</p>
          <p className="sub-text">NFT drop machine with fair mint</p>
          <div className="row">
            <div className="col-sm-4">
              <p className="faq_title">Wen Mint?</p>
              <p>Mint is on March 12th at 20:00 UTC.</p>
            </div>
            <div className="col-sm-4">
              <p className="faq_title">What is Supply?</p>
              <p>222 Chimpz, 222 Baby Chimpz.</p>
            </div>
            <div className="col-sm-4">
              <p className="faq_title">How Much?</p>
              <p>0.59 Sol WL, 0.66 Sol Public.</p>
            </div>
          </div>

          <div className="row">

            <div className="col-sm-4">
              <p className="faq_title"> Wen Breeding?</p>
              <p>Baby Chimpz Sent To Chimp Holders mid-late March.</p>
            </div>
            <div className="col-sm-4">
              <p className="faq_title">Wen Staking?</p>
              <p>Staking will be live within a fortnight after breeding.</p>
            </div>
            <div className="col-sm-4">
              <p className="faq_title">Wen P2E?</p>
              <p>Early To Mid April!</p>
            </div>
          </div>


        </div>
        <p></p>
      </Container>
    </div>
  );
};

export default App;